import { ActionDispatching, LoadOptions } from 'app/types-shared';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { api } from '../api';
import {
  RequestCodetable, ReceiveCodetable, FailCodetable
} from './action-types';
import { mapCurrentOptions, mapListToStore } from './map-to-store';
import { codeFieldIncludeInactive } from 'app/area/indicator-factors/common/codetable-options-handler/constants';
import { CodeFieldWireKey } from 'app/area/indicator-factors/types-store';
import { LoadCodeItemsParams } from 'app/area/indicator-factors/common/types';

export const actionCreators = {

  loadCodetableOptions: (
    id: string,
    codetableId: number,
    loadOptionsParams: LoadOptions,
    optionsParams?: LoadCodeItemsParams): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      dispatch(new RequestCodetable(id, loadOptionsParams));

      try {
        const query = loadOptionsParams && loadOptionsParams.query || undefined;
        const parentId = loadOptionsParams && loadOptionsParams.parentId || undefined;
        const siblingId = loadOptionsParams && loadOptionsParams.siblingId || undefined;
        const displayNotSelected = loadOptionsParams && loadOptionsParams.displayNotSelected;
        const includeNotSelected = loadOptionsParams && loadOptionsParams.includeNotSelected;
        const includeInactiveCodes = (loadOptionsParams && loadOptionsParams.includeInactiveCodes) || codeFieldIncludeInactive.active;
        const code = loadOptionsParams && loadOptionsParams.code;

        const [codes, path] = await Promise.all([
          api.loadCodeItems({
            id: codetableId,
            parentId,
            siblingId,
            query,
            includeInactiveCodes,
            categoryId: loadOptionsParams && loadOptionsParams.categoryId,

            limitFieldsTo: optionsParams?.limitFieldsTo ?? [CodeFieldWireKey.code],

            ...(displayNotSelected !== undefined && { displayNotSelected }),
            ...(includeNotSelected !== undefined && { includeNotSelected }),
            ...(code !== undefined && { code })
          }),
          siblingId !== undefined || parentId !== undefined
            ? api.loadPath(codetableId, siblingId || parentId)
            : Promise.resolve(undefined)]);

        const wireCodes = codes && codes.results || [];
        const pathCodes = codeItemToStoreValue(path || {});
        const storeCodes = mapListToStore(wireCodes, pathCodes);
        const currentOptions = mapCurrentOptions(wireCodes);

        dispatch(new ReceiveCodetable(id, loadOptionsParams, storeCodes, currentOptions));
      } catch (err) {

        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));
        dispatch(new FailCodetable(id, loadOptionsParams));
      }
    }
};
